<template>
  <div :class="{ 'mt-n4 mb-n2': pledgesDontExist }">
    <v-checkbox
      v-if="!body.panttikirjojenKoodit?.length"
      v-model="pledgesDontExist"
      label="Ei panttikirjoja"
    />

    <template v-if="!removePledges">
      <div
        v-for="(koodi, idx) of body.panttikirjojenKoodit"
        :key="idx"
        class="py-2"
      >
        <v-row class="mb-0 mx-0">
          <p>Tunnus: <span class="primary--text">{{ koodi }}</span></p>
          <v-spacer/>
          <v-btn icon @click="remove(idx)">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-row>
      </div>

      <v-btn
        depressed
        color="primary"
        @click="addPledge = true"
      >
        Lisää panttikirja
      </v-btn>
    </template>

    <v-dialog v-model="addPledge" max-width="500">
      <v-card>
        <v-card-title>Lisää panttikirja</v-card-title>
        <v-card-text class="pb-0">
          <v-text-field
            v-model="pledge"
            label="Panttikirjan tunniste"
            hide-details
            :rules="[rules.required]"
          />
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer/>
          <v-btn
            depressed
            color="primary"
            :disabled="!pledge"
            @click="addRow()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    body: {
      type: Object,
      default: () => {},
    },
    removePledges: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    pledge: '',
    pledgesDontExist: false,
    addPledge: false,
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
    },
  }),
  watch: {
    removePledges(value) {
      if (value) {
        this.pledgesDontExist = true;
      }
    },
    pledgesDontExist(value, oldValue) {
      if (value === oldValue) {
        return;
      }

      if (value) {
        // delete this.body.panttikirjojenKoodit;
        this.$bus.$emit('REMOVE_PLEDGES');
      } else {
        // this.body.panttikirjojenKoodit = [];
        this.$bus.$emit('RESTORE_PLEDGES');
      }

      this.$bus.$emit('GET_DIAS_CONFIG');
    },
  },
  methods: {
    addRow() {
      this.body.panttikirjojenKoodit.push(this.pledge);
      this.pledge = '';
      this.addPledge = false;
      this.$bus.$emit('GET_DIAS_CONFIG');
    },
    remove(idx) {
      this.body.panttikirjojenKoodit.splice(idx, 1);
      this.$bus.$emit('GET_DIAS_CONFIG');
    },
  },
};
</script>
